(function(){
  var body;
  var born = (window.performance && performance.now) ? performance.now() : Date.now();
  var MIN_VISIBLE = 450;

  function reveal(){
    body=document.body;
    if(!body)return;
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var wait = Math.max(0, MIN_VISIBLE - (now - born));
    setTimeout(function(){
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          body.classList.remove('moray-loader-leaving');
          body.classList.add('moray-loader-ready');
        });
      });
    }, wait);
  }

  function start(){
    body=document.body;
    if(!body)return;
    body.classList.remove('moray-loader-ready');
    body.classList.add('moray-loader-leaving');
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',reveal,{once:true});
  }else{
    reveal();
  }

  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest&&e.target.closest('a[href]');
    if(!a||a.hasAttribute('download')||(a.target&&a.target.toLowerCase()==='_blank'))return;

    var h=a.getAttribute('href');
    if(!h||h.charAt(0)==='#'||/^javascript:|^mailto:|^tel:/i.test(h))return;

    var u;
    try{u=new URL(a.href,location.href)}catch(err){return}
    if(u.origin!==location.origin||u.href===location.href)return;

    var p=u.pathname.replace(/\/$/,'')||'/';
    if(p==='/'||p.indexOf('/collections/')===0||p.indexOf('/products/')===0)start();
  },true);

  window.addEventListener('pageshow',function(e){
    if(e.persisted)reveal();
  });
})();